if (!customElements.get('search-wrapper')) {
  class SearchWrapper extends HTMLElement {
    constructor() {
      super();

      this.toggleRef = this.toggle.bind(this);
      this.closeRef = this.close.bind(this);
      this.handleClickRef = this.handleClick.bind(this);
    }

    open() {
      this.classList.add('is-open');
    }

    close() {
      this.classList.remove('is-open');
    }

    toggle() {
      return !this.classList.contains('is-open') ? this.open() : this.close();
    }

    handleClick(event) {
      if (window.innerWidth < 990) event.preventDefault();
    }

    connectedCallback() {
      document.addEventListener('search:toggle', this.toggleRef);
      document.addEventListener('click', this.closeRef);
      this.addEventListener('click', this.handleClickRef);
    }
  }

  customElements.define('search-wrapper', SearchWrapper);
}
